import { Auxiliars } from "helpers";
import { IMenu, IUser } from "interfaces";

export interface IPotluck {
  _id: string;
  party_name: string;
  theme: string;
  menu: IMenu[];
  date: string;
  start_time: string;
  end_time: string;
  message: string;
  participants: IUser[];
  created_by: IUser;
}

export const createDefaultPotluck = (): IPotluck => ({
  _id: Auxiliars.generateObjectId(),
  party_name: "",
  theme: "",
  menu: [],
  date: "",
  start_time: "",
  end_time: "",
  message: "",
  participants: [],
  created_by: {} as IUser,
});